import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import About from './components/About';
import Philosophy from './components/Philosophy';
import Testimonials from './components/Testimonials';
import ProcessSection from './components/ProcessSection';
import FAQ from './components/FAQ';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <Hero />
        <nav className="bg-white border-b border-gray-200 sticky top-0 z-40 shadow-sm">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex justify-center items-center py-3 overflow-x-auto">
              <div className="flex space-x-2 sm:space-x-4">
                <a href="#sobre-mi" className="text-sm font-medium text-gray-700 hover:text-primary-600 transition-colors whitespace-nowrap px-3 py-2 rounded-lg hover:bg-primary-50">
                  Sobre Mí
                </a>
                <a href="#filosofia" className="text-sm font-medium text-gray-700 hover:text-primary-600 transition-colors whitespace-nowrap px-3 py-2 rounded-lg hover:bg-primary-50">
                  Filosofía
                </a>
                <a href="#testimonios" className="text-sm font-medium text-gray-700 hover:text-primary-600 transition-colors whitespace-nowrap px-3 py-2 rounded-lg hover:bg-primary-50">
                  Testimonios
                </a>
                <a href="#servicios" className="text-sm font-medium text-gray-700 hover:text-primary-600 transition-colors whitespace-nowrap px-3 py-2 rounded-lg hover:bg-primary-50">
                  Servicios
                </a>
                <a href="#proceso" className="text-sm font-medium text-gray-700 hover:text-primary-600 transition-colors whitespace-nowrap px-3 py-2 rounded-lg hover:bg-primary-50">
                  Proceso
                </a>
                <a href="#preguntas-frecuentes" className="text-sm font-medium text-gray-700 hover:text-primary-600 transition-colors whitespace-nowrap px-3 py-2 rounded-lg hover:bg-primary-50">
                  FAQ
                </a>
                <a href="#contacto" className="text-sm font-medium text-gray-700 hover:text-primary-600 transition-colors whitespace-nowrap px-3 py-2 rounded-lg hover:bg-primary-50">
                  Contacto
                </a>
              </div>
            </div>
          </div>
        </nav>
        <About />
        <Philosophy />
        <Testimonials />
        <Services />
        <ProcessSection />
        <FAQ />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}